import React from 'react';
import { AuthTabs, OtpWhatsAppButton } from '../../components/ui';
import { fmtDateTime } from '../../utils/helpers';

// Desktop Login — centred card. Mobile number first; then a password (staff)
// or a WhatsApp OTP (invited guest). All logic is in useLogin.
export default function LoginDesktop({ vm }) {
  const {
    step, mobile, setMobile, password, setPassword, otp, setOtp, reused, guestName,
    remember, setRemember, busy, err, errReason, autoChecking,
    continueWithMobile, submit, verifyGuest, resendOtp, changeNumber, forgotPassword,
  } = vm;

  const card = (children) => (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-pad" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>Mehfil by Smartify</div>
          {children}
        </div>
      </div>
    </div>
  );

  if (autoChecking) return card(<div className="muted" style={{ marginTop: 12, fontSize: 13 }}>Signing you in…</div>);

  const errBox = err && (
    <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>
      {err}
      {step === 'password' && errReason === 'bad_password' && (
        <> · <button type="button" className="linklike" onClick={forgotPassword}>Reset it with OTP</button></>
      )}
    </div>
  );
  // The number, fixed once it has been checked, with a way back.
  const numberLine = (
    <div className="login-number">
      <span>{mobile}</span>
      <button type="button" className="linklike" onClick={changeNumber}>Change</button>
    </div>
  );

  return card(
    <>
      <div className="muted" style={{ fontSize: 13 }}>
        {step === 'otp' ? `Welcome${guestName ? `, ${guestName}` : ''}` : 'Sign in'}
      </div>
      {step !== 'otp' && <AuthTabs active="signin" />}

      {step === 'mobile' && (
        <form onSubmit={continueWithMobile} style={{ textAlign: 'left' }}>
          <label className="field">Mobile Number
            <input type="tel" autoComplete="tel-national" name="mobile" value={mobile} placeholder="10-digit mobile" autoFocus
              onChange={(e) => setMobile(e.target.value)} />
          </label>
          {errBox}
          <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
            {busy ? 'Checking…' : 'Continue'}
          </button>
        </form>
      )}

      {step === 'password' && (
        <form onSubmit={submit} style={{ textAlign: 'left' }}>
          {numberLine}
          <label className="field">Password
            <input type="password" autoComplete="current-password" value={password} placeholder="Password" autoFocus
              onChange={(e) => setPassword(e.target.value)} />
          </label>
          <button type="button" className="linklike auth-forgot" onClick={forgotPassword}>Forgot password?</button>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 12 }}>
            <input type="checkbox" checked={remember} style={{ width: 'auto' }}
              onChange={(e) => setRemember(e.target.checked)} />
            Keep me signed in on this device
          </label>
          {errBox}
          <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      )}

      {step === 'otp' && (
        <form onSubmit={verifyGuest} style={{ textAlign: 'left', marginTop: 10 }}>
          {numberLine}
          <div className="muted" style={{ fontSize: 13, marginBottom: 10 }}>
            {reused
              ? `Use the OTP already sent to your WhatsApp at ${fmtDateTime(reused)} (valid for 1 hour).`
              : 'We sent a 4-digit code to your WhatsApp.'}
          </div>
          <label className="field">OTP
            <input type="tel" maxLength={4} value={otp} autoComplete="one-time-code" className="auth-mobile-otp" autoFocus
              onChange={(e) => setOtp(e.target.value)} />
          </label>
          <OtpWhatsAppButton />
          {errBox}
          <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
            {busy ? 'Verifying…' : 'Verify & Continue'}
          </button>
          <div style={{ textAlign: 'center', marginTop: 10, fontSize: 13 }}>
            <button type="button" className="linklike" onClick={resendOtp} disabled={busy}>Resend OTP</button>
          </div>
        </form>
      )}
    </>
  );
}
